export default __webpack_public_path__ + "b9c12caa4073b53e697ad1d2d5cb300e.png";